module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "fmt"
  }, [_c('span', [_c('a', {
    attrs: {
      "id": "page_vi"
    }
  }), _c('a', {
    attrs: {
      "id": "page_vii"
    }
  }, [_c('b', [_vm._v("CONTENTS")])])])]), _c('a', {
    attrs: {
      "id": "page_vii"
    }
  }), _c('p', {
    staticClass: "toc2",
    attrs: {
      "id": "rack"
    }
  }, [_c('a', {
    attrs: {
      "id": "page_vii"
    }
  }, [_c('span')]), _c('a', {
    attrs: {
      "href": "#/xhtml/acknowledgments#ack"
    }
  }, [_vm._v("Acknowledgments")])]), _vm._v(" "), _c('p', {
    staticClass: "toc2",
    attrs: {
      "id": "rprl"
    }
  }, [_c('span', [_c('a', {
    attrs: {
      "href": "#/xhtml/prologue#prl"
    }
  }, [_vm._v("Prologue")])])]), _vm._v(" "), _c('div', {
    staticStyle: {
      "margin-left": "1.5em"
    }
  }, [_c('p', {
    staticClass: "hang",
    attrs: {
      "id": "rch01"
    }
  }, [_c('span', [_c('a', {
    attrs: {
      "href": "#/xhtml/chapter01#ch01"
    }
  }, [_c('span', {
    staticClass: "big"
  }, [_vm._v("1")]), _vm._v("  The Encounter: The Many Paths to CrossFit")])])]), _vm._v(" "), _c('p', {
    staticClass: "hang",
    attrs: {
      "id": "rch02"
    }
  }, [_c('span', [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter02#ch02",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "big"
  }, [_vm._v("2")]), _vm._v("  The Unknown and the Unknowable: What Is CrossFit All About?")])])]), _vm._v(" "), _c('p', {
    staticClass: "hang",
    attrs: {
      "id": "rch03"
    }
  }, [_c('span', [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter03#ch03",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "big"
  }, [_vm._v("3")]), _vm._v("  Inside the Box: The World Within a CrossFit Affiliate")])])]), _vm._v(" "), _c('p', {
    staticClass: "hang",
    attrs: {
      "id": "rch04"
    }
  }, [_c('span', [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter04#ch04",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "big"
  }, [_vm._v("4")]), _vm._v("  Making the Invisible Visible: CrossFit’s Focus on Movement and Mobility")])])]), _vm._v(" "), _c('p', {
    staticClass: "hang",
    attrs: {
      "id": "rch05"
    }
  }, [_c('span', [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter05#ch05",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "big"
  }, [_vm._v("5")]), _vm._v("  Two Oars in the Water: CrossFit’s One-Two Punch of Diet and Exercise")])])]), _vm._v(" "), _c('p', {
    staticClass: "hang",
    attrs: {
      "id": "rch06"
    }
  }, [_c('span', [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter06#ch06",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "big"
  }, [_vm._v("6")]), _vm._v("  CultFit: The Community and Sociology of CrossFit")])])]), _vm._v(" "), _c('p', {
    staticClass: "hang",
    attrs: {
      "id": "rch07"
    }
  }, [_c('span', [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter07#ch07",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "big"
  }, [_vm._v("7")]), _vm._v("  Irene’s Journey: A Case Study")])])]), _vm._v(" "), _c('p', {
    staticClass: "hang",
    attrs: {
      "id": "rch08"
    }
  }, [_c('span', [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter08#ch08",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "big"
  }, [_vm._v("8")]), _vm._v("  The Jet Stream of High Performance: The Making of a Firebreather")])])]), _vm._v(" "), _c('p', {
    staticClass: "hang",
    attrs: {
      "id": "rch09"
    }
  }, [_c('span', [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter09#ch09",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "big"
  }, [_vm._v("9")]), _vm._v("  My Date with Fran")])])])]), _vm._v(" "), _c('p', {
    staticClass: "toc1d",
    attrs: {
      "id": "repi"
    }
  }, [_c('span', [_c('span', {
    attrs: {
      "href": "#/xhtml/epilogue#epi",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Epilogue: The Future of CrossFit")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc2",
    attrs: {
      "id": "rglry"
    }
  }, [_c('span', [_c('span', {
    attrs: {
      "href": "#/xhtml/terms#glry",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Glossary of Terms")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc1",
    attrs: {
      "id": "rglry1"
    }
  }, [_c('span', [_c('span', {
    attrs: {
      "href": "#/xhtml/exercises#glry1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Glossary of Exercises")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc1",
    attrs: {
      "id": "rabt"
    }
  }, [_c('span', [_c('span', {
    attrs: {
      "href": "#/xhtml/author#abt",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("About the Author")])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-218d4410","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/contents.vue
// module id = 72
// module chunks = 0